import { Flex, MultiSelect, MultiSelectProps, Text } from "@mantine/core";
import { forwardRef, useState } from "react";

import { StockPlanType } from "@/utils/scmDataStatus";

interface StockPlanMultiProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: string;
}

export interface StockPlansMultiAutoCompleteProps
  extends Partial<MultiSelectProps>,
    Partial<React.RefAttributes<HTMLInputElement>> {
  value: string[];
  onChange?: (e: string[]) => void; // (value: string[]) => React.Dispatch<React.SetStateAction<string>>;
  maxDropdownHeight?: number;
  width?: string;
}

export const StockPlansMultiAutoComplete = (params: StockPlansMultiAutoCompleteProps) => {
  const { value: sites, onChange, maxDropdownHeight, width, ...etcParams } = params;
  const [searchKeyword, setSearchKeyword] = useState<string>("");

  const translatedStockPlans = StockPlanType.map((item) => ({
    ...item,
    label: item.label,
  }));
  const onChangeHandler = (e: string[]) => {
    onChange && onChange(e);
  };

  const SelectStockPlan = forwardRef<HTMLDivElement, StockPlanMultiProps>(
    ({ label: name, value: code, ...others }, ref) => (
      <div ref={ref} {...others}>
        <Flex direction="row" justify="space-between" align="center">
          <Flex align={"center"}>
            <Text>{name}</Text>
            <Text fz="xs">(재고계획상태: {code})</Text>
          </Flex>
        </Flex>
      </div>
    ),
  );

  return (
    <MultiSelect
      clearable
      data={translatedStockPlans}
      onChange={onChangeHandler}
      searchable
      itemComponent={SelectStockPlan}
      searchValue={searchKeyword}
      withinPortal
      maxDropdownHeight={maxDropdownHeight ?? 150}
      onSearchChange={setSearchKeyword}
      nothingFound="No Options"
      {...etcParams}
    />
  );
};
